module.exports = __webpack_public_path__ + "static/img/index-pro-招标.9b0dcb79.png";